<template>
  <div class="side-panel">
    <v-layout white>
      <search-bar @search="filteredGroups = filterTable(groups, $event)" :columns="headers"></search-bar>
      <v-spacer></v-spacer>
      <v-flex align-self-center shrink>
        <v-btn
          @click="createGroupModalVisible = true"
          class="secondary"
          medium>
          {{$t('groupDetails.createGroup')}}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="filteredGroups"
      hide-actions
      :loading="loading && error === null"
    >
        <template slot="items" slot-scope="props">
          <tr @click="editGroupModalVisible = true; clickedId = props.item.group_id">          
            <td class="text-xs-center">{{ props.item.group_name }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
          </tr>
        </template>
    </v-data-table>
    <div class="danger-alert" v-if="error"> {{error}} </div>
    <v-dialog v-model="createGroupModalVisible" max-width="500px">
      <create-group v-on:close="createGroupModalVisible = false; loadData()"></create-group>
    </v-dialog>    
    <v-dialog v-model="editGroupModalVisible" max-width="500px">
      <edit-group v-on:close="editGroupModalVisible = false; loadData()" :selectedId="this.clickedId"></edit-group>
    </v-dialog>
  </div>
</template>

<script>
import GroupsApi from '@/api/groups-api'
import CreateGroup from '@/components/CreateGroup'
import EditGroup from '@/components/EditGroup'
import FilterTable from '@/helpers/FilterTable.js'

export default {
  components: {
    CreateGroup,
    EditGroup
  },
  mixins: [FilterTable],
  data () {
    return {
      headers: [
        { text: this.$t('groupGenerics.groupName'),
          value: 'group_name',
          align: 'center' },
        { text: this.$t('groupGenerics.groupDesc'),
          value: 'description',
          align: 'center' }
      ],
      error: null,
      groups: [],
      loading: null,
      createGroupModalVisible: false,
      editGroupModalVisible: false,
      clickedId: null,
      filteredGroups: []
    }
  },
  async mounted () {
    await this.loadData()
  },
  methods: {
    async loadData () {
      try {
        this.loading = true
        this.filteredGroups = this.groups = (await GroupsApi.index()).data
        this.loading = false
      } catch (err) {
        this.error = err.response.data.error.message
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Groups.vue